import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const ProcurementData = () => {
    
    const sections = [
        { label: "Legal Entity", value: "LegalEntity", items: [] },
        { label: "Material Category", value: "MaterialCategory", items: [] },
        { label: "Material Procurement Status", value: "MaterialProcurementStatus", items: [] },
        { label: "Procurement Method", value: "ProcurementMethod", items: [] },
        { label: "Service Category", value: "ServiceCategory", items: [] },
        { label: "Source Department", value: "SourceDepartment", items: [] },
        { label: "Services Packages", value: "servicesPackages", items: [] },
        { label: "UOM", value: "UOM", items: [] },
        { label: "Vendor Name", value: "VendorName", items: [] },
        { label: "Status", value: "Status", items: [] },
        { label: "Admin Status", value: "AdminStatus", items: [] },
    ];

    return (
        <MasterData pageTitle="Procurement" sections={sections} />
    );
};

export default ProcurementData;